import React, { Component } from 'react'
import { get, headers } from '../../lib/fetch'
import LocationSearch from '../LocationSearch'
import styled from 'styled-components'
import { SCREEN_SIZE } from '../../lib/Media'
import Popup from '../Popup'
import RemoveIcon from '../icons/Close'
import { getCurrentHost } from '../../utils/Utils'
import { getUserType } from '../../utils/userType'

const StyledDeliveryPickupForm = styled.div`
  background-color: #ffffff;
  box-shadow: 0px 15px 15px 2px rgba(0, 0, 0, 0.15);
  transform: none;
  width: 95%;
  border-radius: 0.25rem;
  ${SCREEN_SIZE.From.MobileL} {
    width: 33rem;
    padding: 1rem 1.5rem;
  }
  padding: 1rem 0.5rem;
  position: absolute;
  left: 0;
  right: 0;
  top: 6rem;
  margin: auto;
  height: auto;
  border: 1px solid #eaeaea !important;
`

const StyledRemoveIcon = styled(RemoveIcon)`
  cursor: pointer;
  top: 1rem;
  right: 1rem;
  height: 1rem;
  width: 1rem;
  position: absolute;
  z-index: 1002;
`

class Content extends Component {
  render() {
    const { onHandleClose, savedAddresses, isLoggedIn, uncloseable } =
      this.props
    return (
      <React.Fragment>
        {!uncloseable && <StyledRemoveIcon onClick={onHandleClose} />}
        <LocationSearch
          setLocation={location =>
            this.props.setLocation(location, onHandleClose)
          }
          popup={true}
          onHandleClose={onHandleClose}
          savedAddresses={savedAddresses}
          isLoggedIn={isLoggedIn}
        />
      </React.Fragment>
    )
  }
}
class AddressPopup extends Component {
  constructor(props) {
    super(props)

    this.setLocation = this.setLocation.bind(this)
    this.updateLocation = this.updateLocation.bind(this)
    this.onHandleUpdate = this.onHandleUpdate.bind(this)
    this.fetchSavedAddress = this.fetchSavedAddress.bind(this)
  }

  onHandleUpdate() {
    this.props.onHandleClose()
    this.updateLocation(this.location)
  }

  updateLocation(location) {
    this.props.updateCheckoutAddress &&
      this.props.updateCheckoutAddress(location, true, true)
  }

  setLocation(location, toggle) {
    location.address && toggle()
    this.updateLocation(location)
  }

  async fetchSavedAddress() {
    const callback = response => {
      const addressType = getUserType() === 'B2B' ? 'BIZ' : 'PRS'
      const savedAddresses = (response.addresses || []).filter(
        address => address.type === addressType
      )
      this.setState({
        savedAddresses: savedAddresses,
      })
    }

    await get(`${getCurrentHost()}/user-profile`, {
      headers: headers(),
    }).then(callback)
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.fetchSavedAddress()
    }
  }

  render() {
    const savedAddresses = this.state && this.state.savedAddresses

    return (
      <Popup
        onClose={this.props.onHandleClose}
        forceAcknowledge={!!this.props.uncloseable}
      >
        <StyledDeliveryPickupForm>
          <Content
            uncloseable={!!this.props.uncloseable}
            setLocation={this.setLocation}
            savedAddresses={savedAddresses}
            onHandleClose={this.props.onHandleClose}
            isLoggedIn={this.props.isLoggedIn}
          />
        </StyledDeliveryPickupForm>
      </Popup>
    )
  }
}

AddressPopup.defaultProps = {
  checkoutAddress: {},
}

export default AddressPopup
